import { Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import {
	NON_US_PRIVACY_POLICY_URL,
	US_PRIVACY_POLICY_URL,
} from 'src/app/app.constants';
import { ExternalLinkDirective } from 'src/app/directives/external-link.directive';
import { CookieConsentService } from 'src/app/services/cookie-consent.service';

@Component({
	selector: 'app-cookie-consent-bar',
	templateUrl: './cookie-consent-bar.component.html',
	styleUrls: ['./cookie-consent-bar.component.scss'],
	imports: [MatButtonModule, ExternalLinkDirective],
})
export class CookieConsentBarComponent {
	readonly cookieConsent = inject(CookieConsentService);

	readonly nonUsPrivacyPolicyUrl = NON_US_PRIVACY_POLICY_URL;
	readonly usPrivacyPolicyUrl = US_PRIVACY_POLICY_URL;
}
